module.exports = __webpack_public_path__ + "static/media/lobby.cc36e51e.jpg";